import { useAsyncData } from '#imports'

import type { AlgoliaLink } from '@backmarket/http-api/src/api-specs-search-reco/search/searchAlgolia'
import type { IndexSearch } from '@backmarket/http-api/src/api-specs-search-reco/search/searchConfiguration'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'

// DO NOT REMOVE THIS UNUSED IMPORT
// It is necessary for the translations-split-v2 feature to know to load the translations in ./helpers.translations.ts for the routes that use the getSortOptions function
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import helpersTranslations from './helpers.translations'

export function getHighlightedTitleFromSearch(suggestion: AlgoliaLink) {
  // eslint-disable-next-line no-underscore-dangle
  return suggestion._highlightResult?.title.value ?? ''
}

// TODO extract component into composable folder
export function useAlgoliaConfiguration(scope: string, id?: string) {
  const $httpFetch = useHttpFetch()

  const dataHandler = async () => {
    const config = id
      ? await $httpFetch('/bm/search/v2/configuration/:scope/:id', {
          pathParams: { scope, id },
        })
      : await $httpFetch('/bm/search/v2/configuration/:scope', {
          pathParams: { scope },
        })

    // WHY: usages.label is facetable in Algolia but not exposed in the API
    // search configuration. The backend team chose not to add it to the config
    // (see SR-4901 for context on the collection_usage indexing). We inject it
    // client-side so TopFilters displays active usage selections natively.
    // TODO: Remove this injection once the API config includes usages.label.
    config.facets = [
      ...config.facets,
      { name: 'usages.label', title: 'Usage', type: 'checkbox' as const },
    ]

    return config
  }

  return id
    ? useAsyncData(`search-config-${scope}-${id}`, dataHandler, {
        getCachedData: (key, app) => app.payload.data[key],
      })
    : useAsyncData(`search-config-${scope}`, dataHandler, {
        getCachedData: (key, app) => app.payload.data[key],
      })
}

// TODO: rename and extract into composable folder
export function getSortOptions(indexes: {
  active: IndexSearch
  other?: IndexSearch[]
}) {
  const i18n = useI18n()

  return [indexes.active, ...(indexes?.other ?? [])].map((index) => {
    const label = i18n({ id: index.title, defaultMessage: index.title })

    return {
      label,
      value: index.name,
      title: index.title,
    }
  })
}
